import React from 'react';
import { useThemeContext } from '@context/ThemeContext';
import Modal from '@modals/Modal';
import Popup from '@modals/Popup';

const GlobalModal = () => {
  const { error, clearError } = useThemeContext();
  const showError = error && error.trim().length > 0;

  return (
    <Modal show={showError} type="error">
      <Popup type="error">
        <div className='error-wrapper'>
          <h3 className='error-text'>{error}</h3>
          <button className='error-btn' onClick={clearError}>OK</button>
        </div>
      </Popup>
    </Modal>
  );
};

export default GlobalModal;
